import { EShippingType } from '@/enums/EShippingType';

const getShippingTypeName = (status: EShippingType | undefined): string => {
  switch (status) {
    case EShippingType.TRUCK:
      return 'TRUCK';
    case EShippingType.PUIS:
      return 'PICK UP';
    case EShippingType.AIR:
      return 'AIR';
    case EShippingType.VESSEL:
      return 'VESSEL';
    default:
      return '';
  }
};

const getShippingTypeOptions = () =>
  Object.entries(EShippingType).map(([value]) => ({
    label: getShippingTypeName(value as EShippingType),
    value: value as EShippingType,
  }));

export { getShippingTypeOptions, getShippingTypeName };
